/** 1C ERP native accounting account analytics dimensions */
export enum Erp1cAnalyticDimensionKeyEnum {
  /** Other financial flows */
  OTHER_INCOME_EXPENSE = 'otherIncomeExpense',
  /** Warehouse */
  WAREHOUSE = 'warehouse',
  /** Cash/Flow item */
  CASH_FLOW_ITEM = 'cashFlowItem',
  /** Cost item */
  COST_ITEM = 'costItem',
  /** Item */
  ITEM = 'item',
  /** Contract */
  CONTRACT = 'contract',
  /** Counterparty */
  COUNTERPARTY = 'counterparty'
}
